import { useEffect, useState } from "react";
import "./AdminCategoriaBanner.css";
import EditarCategoriaBanner from "./EditarCategoriaBanner/EditarCategoriaBanner";
import CriarCategoriaBanner from "./CriarCategoriaBanner/CriarCategoriaBanner";

function AdminCategoriaBanner({
    banners,
    onClose,
    atualizarBanners,
}) {
    const [categorias, setCategorias] = useState([]);
    const [bannerEditando, setBannerEditando] =
        useState(null);

    const [abrirCriar, setAbrirCriar] =
        useState(false);

    useEffect(() => {
        carregarCategorias();
    }, []);

    const carregarCategorias = async () => {
        try {
            const response = await fetch(
                "https://app.eliandroalimentos.com.br/api/categorias/listargrupos"
            );

            const data = await response.json();

            setCategorias(data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleFechar = () => {
        if (bannerEditando) {
            setBannerEditando(null);
            return;
        }

        onClose?.();
    };

    const categoriasDisponiveis =
        categorias.filter(
            (categoria) =>
                !banners.some(
                    (banner) =>
                        Number(banner.ordem) ===
                        Number(categoria.codgrupo)
                )
        );

    return (
        <>
            <div className="adminCategoriaBanner-container">

                <div className="adminCategoriaBanner-header">

                    <h2>
                        Banners das Categorias
                    </h2>

                    <div className="adminCategoriaBanner-acoes">

                        <button
                            className="adminCategoriaBanner-add"
                            onClick={() =>
                                setAbrirCriar(true)
                            }
                        >
                            + Adicionar
                        </button>

                        <button
                            className="adminCategoriaBanner-fechar"
                            onClick={handleFechar}
                        >
                            ✕
                        </button>

                    </div>

                </div>

                <div className="adminCategoriaBanner-lista">

                    {banners.length === 0 && (
                        <div className="adminCategoriaBanner-vazio">
                            Nenhum banner cadastrado.
                        </div>
                    )}

                    {banners.map((banner) => {

                        const categoria =
                            categorias.find(
                                (c) =>
                                    Number(c.codgrupo) ===
                                    Number(banner.ordem)
                            );

                        return (
                            <div
                                key={banner.id}
                                className="adminCategoriaBanner-item"
                            >



                                <div className="adminCategoriaBanner-info">

                                    <div className="adminCategoriaBanner-nome">
                                        {categoria?.descricao ??
                                            "Categoria não encontrada"} - Grupo: {banner.ordem}
                                    </div>


                                </div>

                                <button
                                    className="adminCategoriaBanner-btnEditar"
                                    onClick={() =>
                                        setBannerEditando(banner)
                                    }
                                >
                                    Editar
                                </button>

                            </div>
                        );
                    })}

                </div>

            </div>

            {bannerEditando && (
                <div
                    className="admin-modal-overlay"
                    onClick={() =>
                        setBannerEditando(null)
                    }
                >
                    <div
                        className="admin-modal"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        <EditarCategoriaBanner
                            banner={bannerEditando}
                            onClose={() =>
                                setBannerEditando(null)
                            }
                            onSalvar={() => {
                                atualizarBanners?.();
                                setBannerEditando(null);
                            }}
                        />

                    </div>
                </div>
            )}

            {abrirCriar && (
  <CriarCategoriaBanner
    categorias={
      categoriasDisponiveis
    }
    onClose={() =>
      setAbrirCriar(false)
    }
    onSalvar={() => {
      atualizarBanners?.();
      setAbrirCriar(false);
    }}
  />
)}
        </>
    );
}

export default AdminCategoriaBanner;